module.exports = __webpack_public_path__ + "static/media/Matt Maple Headshot_1685531552344.ebdd28be.png";